// extracted by mini-css-extract-plugin
export default {"label":"Location_label__P0RlS"};